/* @flow */

import React from "react";
import cn from "classnames";

import styles from "./styles.scss";

type InputProps = React$ElementProps<"input"> & {
  labelClassName?: string,
  label?: string,
};

const TextArea = ({
  id = null,
  className,
  labelClassName,
  name,
  label,
  errors,
  ...props
}: InputProps): React$Node => (
  <div className={styles.block}>
    {label &&
      <label id={id} className={cn(styles.label, labelClassName)}>{label}</label>
    }

    <textarea
      {...props}
      className={cn(styles.input, className)}
      name={name}
      rows="4"
    />
  </div>
);

export default TextArea;
